import { jsx as _jsx } from "react/jsx-runtime";
import { useShareListing } from '@client/hooks/useShareListing';
import { useFavorites } from '@client/providers/FavoritesProvider';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { FaRegShareFromSquare } from 'react-icons/fa6';
import { ListingCard, ListingCardIconMenu } from './ListingCard';
export const ListingDisplayCard = (props) => {
    const shareListing = useShareListing();
    const { favoriteIds, toggleFavorite } = useFavorites();
    const isSaved = favoriteIds.has(props.shortId);
    return (_jsx(ListingCard, { ...props, actionMenu: _jsx(ListingCardIconMenu, { items: [
                {
                    icon: FaRegShareFromSquare,
                    onClick: () => shareListing(props),
                },
                {
                    icon: isSaved ? FaHeart : FaRegHeart,
                    onClick: () => toggleFavorite(props),
                    color: isSaved ? 'red.600' : undefined,
                },
            ] }) }));
};
